'use client'

import { useCallback } from 'react'

import { useEndCustomerSession } from 'composition/session/useEndCustomerSession'
import { useDeliverySupport } from 'modules/delivery'

/**
 * The API has no endpoint that would revoke the support session token, so all
 * we can do is drop the session and every trace of the customer's data on this
 * device. The postal code goes too — it belongs to the impersonated customer
 * and must not survive into the employee's own session.
 */
export const useSupportSessionExit = () => {
  const logout = useEndCustomerSession()
  const { clearPostalCode } = useDeliverySupport()

  return useCallback(() => logout(clearPostalCode), [logout, clearPostalCode])
}
